import React from 'react';
import Icon, { IconProps } from '../Icon';

const IconBoldChat: React.FC<IconProps> = ({ ...props }) => {
  const fill = props.fill || '#262626';
  return (
    <Icon {...props}>
      <path
        d="M8.571 12c0-0.951-0.763-1.714-1.714-1.714s-1.714 0.763-1.714 1.714 0.763 1.714 1.714 1.714 1.714-0.763 1.714-1.714zM13.714 12c0-0.951-0.763-1.714-1.714-1.714s-1.714 0.763-1.714 1.714 0.763 1.714 1.714 1.714 1.714-0.763 1.714-1.714zM18.857 12c0-0.951-0.763-1.714-1.714-1.714s-1.714 0.763-1.714 1.714 0.763 1.714 1.714 1.714 1.714-0.763 1.714-1.714zM24 12c0 4.741-5.371 8.571-12 8.571-0.978 0-1.929-0.080-2.826-0.241-1.527 1.527-3.522 2.571-5.826 3.067-0.362 0.067-0.75 0.134-1.152 0.174-0.214 0.027-0.415-0.121-0.469-0.321v0c-0.054-0.214 0.107-0.348 0.268-0.496 0.844-0.79 1.848-1.42 2.196-4.246-2.558-1.567-4.192-3.897-4.192-6.509 0-4.741 5.371-8.571 12-8.571s12 3.83 12 8.571z"
        fill={fill}
      />
    </Icon>
  );
};

export default IconBoldChat;
